import Autofinanzierung from '@allesauto/design/graphics/Autofinanzierung.svg';
import Elektroautos from '@allesauto/design/graphics/Elektroautos.svg';
import Gebrauchtwagen from '@allesauto/design/graphics/Gebrauchtwagen.svg';
import Leasingfahrzeuge from '@allesauto/design/graphics/Leasingfahrzeuge.svg';
import Neuwagen from '@allesauto/design/graphics/Neuwagen.svg';
import SofortVerfugbar from '@allesauto/design/graphics/Sofort-Verfugbar.svg';
import translate from '@allesauto/i18n';
import { pushAnalyticsEvent } from '@allesauto/utils/analytics';
import { formatPrice } from '@allesauto/utils/funcs';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

interface FilterBoxItemProps {
  icon: string;
  name: string;
  startingPrice: number;
  availableCars: number;
  searchUrl: string;
}

const cssClasses = {
  container: clsx(
    'flex flex-col items-center justify-center text-center w-full',
    'border-[2px] p-10px md:pb-[16px] md:pt-0 md:px-[26px]',
    'bg-white border-white no-underline rounded-default text-grey80 hover:border-red60 active:border-purple80'
  ),
  availableCarsContainer: 'pt-[8px] md:pt-[16px] w-full',
  icon: 'w-[50px] h-[40px] md:w-[90px] md:h-[60px] object-contain text-purple80 mb-10px md:mb-[16px]',
  bold: 'font-weight-bold',
  carInfo:
    'h-[90px] md:h-[160px] w-full flex items-center justify-end flex-col pb-10px md:pb-20px place-content-center border-b-1px border-b-grey30',
};

const FilterBoxItem = (props: FilterBoxItemProps) => {
  const { name, icon, searchUrl = '/', startingPrice, availableCars } = props;
  const intl = useIntl();
  const router = useRouter();

  const vehicleIconList: Record<
    string,
    React.FC<React.SVGProps<SVGSVGElement>>
  > = {
    EletricCars: Elektroautos,
    NewCars: Neuwagen,
    UsedCars: Gebrauchtwagen,
    LeasingCars: Leasingfahrzeuge,
    CarFinancing: Autofinanzierung,
    AvailableImmediately: SofortVerfugbar,
  };

  const VehicleIconDisplay = vehicleIconList[icon] || Gebrauchtwagen;

  function getFormattedPrice(price: number) {
    return formatPrice(intl, price, {
      withFractionDigits: true,
    });
  }

  const onBoxClick = () => {
    pushAnalyticsEvent({
      event: 'filter_box_individual_click',
      box_name: name,
      url: searchUrl,
    });

    router.push(searchUrl);
  };

  return (
    <button onClick={onBoxClick} className={cssClasses.container}>
      <div className={cssClasses.carInfo}>
        <VehicleIconDisplay className={cssClasses.icon} />
        <p className={cssClasses.bold}>{name}</p>
        {startingPrice ? (
          <span>{`${translate(
            intl,
            'ui.FILTER_PAGE.PRICE_FROM'
          )} ${getFormattedPrice(startingPrice)}`}</span>
        ) : null}
      </div>
      {availableCars ? (
        <div className={cssClasses.availableCarsContainer}>
          <span className={cssClasses.bold}>{`${availableCars} ${translate(
            intl,
            'ui.FILTER_PAGE.OFFERS'
          )}`}</span>
        </div>
      ) : null}
    </button>
  );
};

export default FilterBoxItem;
